import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InterceptorSkipHeader } from 'app/auth/auth.interceptor';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {

  constructor(
    private http: HttpClient
  ) { }

  header = {
    headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.accessToken,
    }),
    responseType: 'text',
  };

  get accessToken(): string {
    return localStorage.getItem('accessToken') ?? '';
  }

  submitBusinessCard(loggedIn: string, details: any): Observable<any> {
    if(loggedIn == 'true') {
      return this.http.post(
        API_ENDPOINTS.BASE_URL + '' + 
        `${API_ENDPOINTS.IMSME_SUBMIT_BUSINESS_CARD_AUTH}`,
        details
      )
    } else {
      return this.http.post(
        API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.IMSME_SUBMIT_BUSINESS_CARD_NOAUTH}`,
        details,
        { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } }
      )
    }
  }

  submitChatbotRating(loggedIn: string, details: any): Observable<any> {
    if(loggedIn == 'true') {
      return this.http.post(
        API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.IMSME_SUBMIT_CHATBOT_RATING_AUTH}`,
        details,
      )
    } else {
      return this.http.post(
        API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.IMSME_SUBMIT_CHATBOT_RATING_NOAUTH}`,
        details,
        { headers: { [InterceptorSkipHeader]: InterceptorSkipHeader } }
      )
    }
  }
}
